export default {
    state: {
        sideValue: 'darkColor', // 侧边栏样式
        topValue: 'lightColor', // 顶边栏样式
        navigationMode: 'leftVertical' , // 导航栏模式 leftVertical:左侧垂直  topCross:顶部横向  leftSplit:左侧垂直拆分  leftColumn:左侧垂直分栏
        sideWidth: 200, // 侧边栏宽度
        switchAnimation: true, // 切换动画
        switchMode: 'breadcrumb', // 切换模式
        multiTabShow: true, // 是否显示多标签
    },
    mutations: {
        SET_SIDE_VALUE(state, value) {
            state.sideValue = value
        },
        SET_TOP_VALUE(state, value) {
            state.topValue = value
        },
        SET_NAVIGATION_MODE(state, value) {
            state.navigationMode = value
        },
        SET_SIDE_WIDTH(state, value) {
            state.sideWidth = value
        },
        SET_SWITCH_ANIMATION(state, value) {
            state.switchAnimation = value
        },
        SET_SWITCH_MODE(state, value) {
            state.switchMode = value
        },
        SET_MULTI_TAB_SHOW(state, value) {
            state.multiTabShow = value
        }
    },
    actions: {
        setSideValue({ commit }, value) {
            commit('SET_SIDE_VALUE', value)
        },
        setTopValue({ commit }, value) {
            commit('SET_TOP_VALUE', value)
        },
        setNavigationMode({ commit }, value) {
            commit('SET_NAVIGATION_MODE', value)
        },
        setSideWidth({ commit }, value) {
            commit('SET_SIDE_WIDTH', value)
        },
        setSwitchAnimation({ commit }, value) {
            commit('SET_SWITCH_ANIMATION', value)
        },
        setSwitchMode({ commit }, value) {
            commit('SET_SWITCH_MODE', value)
        },
        setMultiTabShow({ commit }, value) {
            commit('SET_MULTI_TAB_SHOW', value)
        }
    }
}